import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { Typography } from "@mui/material";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import MainFormsCreateClass from "./components/MainFormsCreateClass";
import { InputValueNewClassRoom } from "../../../domains/class-room";
import { alertError, alertSuccess } from "../../../components/alert/swal";
import { classRoomApi } from "../../../api/class-room/class-room.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
import { degreeApi } from "../../../api/degree/degree.api";

type Props = {};

const CreateClassRoom: React.FC<Props> = ({ }: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const [isCanEdit, setIsCanEdit] = useState<boolean>(true);
  const [dataDegree, setDataDegree] = useState<any[]>([]);
  const [dataFaculty, setDataFaculty] = useState<any[]>([]);
  const [errorMessage, setErrorMessage] = useState<any[]>([]);

  const [inputValue, setInputValue] = useState<InputValueNewClassRoom>({
    degree: 0,
    faculty: 0,
    start_academic_year: 0,
    end_academic_year: 0,
    class: "",
    advisor: [], // This is initially an empty array but will be populated with Advisor objects
    evaluation_form_type: 0,
    id_academic_year: null
  });

  const getDataDegree = async () => {
    await degreeApi.getDegree().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataDegree(data.data);
      } else {
        setDataDegree([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  const getDataFacalty = async () => {
    await facultyApi.listFaculty().then((res) => {
      if (res.status < 300) {
        const data = res.data;
        setDataFaculty(data.data);
      } else {
        setDataFaculty([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  const handleClearError = () => setErrorMessage([]);

  useEffect(() => {
    getDataDegree();
    getDataFacalty();
  }, []);

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const validateForm = () => {
    const errors: string[] = [];

    // Check if required fields are empty
    if (!inputValue.degree) {
      errors.push("degree");
    }

    if (!inputValue.faculty) {
      errors.push("faculty");
    }

    if (!inputValue.start_academic_year) {
      errors.push("start_academic_year");
    }

    if (!inputValue.end_academic_year) {
      errors.push("end_academic_year");
    }

    if (!inputValue.class) {
      errors.push("class");
    }

    if (!inputValue.evaluation_form_type) {
      errors.push("evaluation_form_type");
    }

    setErrorMessage(errors);

    // If there are no errors, return true
    return errors.length === 0;
  };

  const handleSave = async (dataBody: any) => {
    if (validateForm()) {
      try {
        dispatch(unsetLoading());

        const degree_name = dataDegree.find(
          (item) => item.id_degree === inputValue.degree
        );

        const faculty_name = dataFaculty.find(
          (item) => item.id_faculty === inputValue.faculty
        );

        const dataAdvisor = [
          ...inputValue.advisor.map((item: any) => ({
            id_employee: item.employee_id,
            // advisor_type: item.advisor_type,
            advisor_type: item.advisor_type_name,
            status: "active",
          })),
        ];

        const response = await classRoomApi.createClassRoom({
          class_room: {
            id_degree: inputValue.degree,
            degree_name: degree_name.degree_name,
            id_faculty: inputValue.faculty,
            faculty_name: faculty_name.faculty_name,
            year_start: inputValue.start_academic_year,
            year_end: inputValue.end_academic_year,
            room: inputValue.class,
            status: "active",
            id_academic_year: inputValue.id_academic_year || null,
            id_advisor_form: inputValue.evaluation_form_type,
          },
          class_room_employee: dataAdvisor,
        });
        if (response.status < 300) {
          alertSuccess(
            "บันทึกชั้นเรียน",
            "บันทึกชั้นเรียน เรียบร้อยแล้ว",
            undefined,
            () => {
              navigate(routeName.cms.ManageClassRoom);
            }
          );
        }
      } catch (error) {
        alertError("บันทึกชั้นเรียน ไม่สำเร็จ");
      } finally {
        dispatch(unsetLoading());
      }
    }
  };

  // console.log("inputValue", inputValue);

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: "จัดการชั้นเรียน",
            key: "1",
            pathName: routeName.cms.ManageClassRoom,
          },
          {
            name: "เพิ่มชั้นเรียน",
            key: "2",
            pathName: routeName.cms.CreateClassRoom,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">เพิ่มชั้นเรียน</Typography>
      </section>

      <section className="w-full mt-4">
        <MainFormsCreateClass
          inputValue={inputValue}
          setInputValue={setInputValue}
          handleClearError={handleClearError}
          isCanEdit={isCanEdit}
          action={"create"}
          isViewOnly={false}
          errorMessage={errorMessage}
        />
      </section>

      <section
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "24px",
        }}
      >
        <ButtonOutlined
          onClick={() => {
            navigate(routeName.cms.ManageClassRoom);
          }}
          mode="del"
          buttonName="ยกเลิก"
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />
        <ButtonPrimary
          onClick={() => {
            handleSave(inputValue);
          }}
          mode="success"
          buttonName="ยืนยัน"
          btnProps={{
            width: "125px",
            margin: "12px",
          }}
        />
      </section>
    </div>
  );
};

export default CreateClassRoom;
